import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import { Grid, Dialog, Paper, FormControl, Input, InputLabel, Button, InputAdornment, IconButton, Snackbar, Typography } from '@material-ui/core'
import '../styles/auth-pages.css'
import logo from '../images/logo_light.png'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { logInAction, recoverPasswordAction } from '../actions/user'
import { resetErrors } from '../actions/global'

const styles = theme => ({
    root: {
        color: 'inherit',
        fontFamily: 'Montserrat',
        display: 'flex'
    },
    cssLabel: {
        font: 'inherit',
        color: 'inherit',
        '&$cssFocused': {
            color: 'white',
        },
    },
    cssFocused: {},

    cssUnderline: {
        borderBottom: 'white !important',
        '&:after': {
          borderBottom: `1px solid white`,          
      },              
      '&:focused::after': {
          borderBottom: `1px solid white`,
      },              
      '&:error::after': {
          borderBottom: `1px solid white`,
      },                      
      '&:before': {
          borderBottom: `1px solid white`,          
      },
      '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `1px solid gray !important`,
      },
      '&$disabled:before': {
          borderBottom: `1px solid white`,
      },         
    }
});

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            showPassword: false,
            showPasswordRecovery: false
        };
    };

    onLogin = (event) => {
        event.preventDefault();

        let auth = {
            username: this.state.email,
            password: this.state.password,
        }

        this.props.logInAction(auth, this.props.history);
    }

    onChangePassword = (event) => {
        event.preventDefault();

        let auth = {
            email: this.state.email
        }

        this.props.recoverPasswordAction(auth, this.props.history);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handlePasswordDialog = () => {
        this.setState(state => ({ showPasswordRecovery: !state.showPasswordRecovery }))
    }

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }))
    }

    handleSnackbarClose = () => {
        this.props.resetErrors();
    };

    render(){
        const { classes } = this.props;
        return(
            <div className="auth-background">
                <Dialog
                    style={{textAlign:'center'}}
                    fullWidth
                    maxWidth={'sm'}
                    open={this.state.showPasswordRecovery}
                    onClose={this.handlePasswordDialog}
                >
                    <Typography style={{margin:'10px'}}>
                    Deseja enviar uma nova senha para o seu e-mail?
                    </Typography>
                    <br/>
                    <Button
                        onClick={this.onChangePassword}>
                        Sim
                    </Button>
                    <Button
                        onClick={this.handlePasswordDialog}>
                        Não
                    </Button>

                </Dialog>
                <Grid container direction="row">
                    <Grid item xs      sm={8} md={8}/>
                    <Grid item xs={12} sm={4} md={3}> 
                        <Paper square className='auth-container' style={{textAlign:"left"}}>
                            <Grid 
                                container 
                                alignContent="center"
                                direction="column"
                                >
                                <Grid
                                    item
                                    container
                                    justify='center'
                                    alignContent='center'>
                                    <img className='logo' src={logo} alt="logo"/>
                                </Grid>
                                <div className='input-form'>
                                <Grid item>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="email-input"
                                            classes={{
                                                root: classes.cssLabel,
                                                focused: classes.cssFocused
                                            }}
                                            className='input-label'
                                        >
                                            E-mail cadastrado
                                        </InputLabel>
                                            <Input
                                                classes={{
                                                    root: classes.root,
                                                    focused: classes.cssFocused,
                                                    underline: classes.cssUnderline,
                                                }}
                                                className='input-field'
                                                id="email-input"
                                                type="email" required
                                                name="email"
                                                onChange={this.handleChange}
                                            />
                                    </FormControl >
                                </Grid>
                                <Grid item>
                                    <FormControl 
                                        fullWidth>
                                        <InputLabel htmlFor="password-input"
                                            classes={{
                                                root: classes.cssLabel,
                                                focused: classes.cssFocused,
                                            }}
                                            className='input-label'
                                        >
                                            Senha
                                        </InputLabel>
                                        <Input
                                            classes={{
                                                root: classes.root,
                                                focused: classes.cssFocused,
                                                underline: classes.cssUnderline,
                                            }}
                                            className='input-field'
                                            id="password-input"
                                            type={this.state.showPassword ? "text" : "password"} required
                                            name="password"
                                            onChange={this.handleChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="Muda a visibilidade da senha"
                                                        onClick={this.handleClickShowPassword}
                                                    >
                                                    {this.state.showPassword ? <Visibility style={{color:'white'}}/> : <VisibilityOff style={{color:'white'}}/>}
                                                    </IconButton>
                                                </InputAdornment>
                                        }/>
                                    </FormControl>
                                </Grid>
                                </div>
                                <Grid item sm={1}>
                                    <Button
                                        className='password-button'
                                        onClick={this.handlePasswordDialog}
                                    >ESQUECI MINHA SENHA</Button>
                                </Grid>
                                <Grid 
                                    container 
                                    direction="row"
                                    justify='space-evenly'>                                    
                                    <Grid item>
                                        <Link to='/cadastro'>
                                            <Button 
                                                variant="contained"
                                                className='contained-button'
                                            >
                                                REGISTRAR-SE
                                            </Button>
                                        </Link>
                                    </Grid>
                                    <Grid item/>
                                    <Grid item>
                                        <Button 
                                            variant="contained" 
                                            className='contained-button'
                                            onClick={this.onLogin}>
                                            LOGIN
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <Snackbar 
                                        open={this.props.errors.loginError ? true : false}
                                        message={this.props.errors.loginError}
                                        type='error'
                                        onClose={this.handleSnackbarClose}/>
                                    <Snackbar 
                                        open={this.props.errors.changePassword ? true : false}
                                        message={this.props.errors.changePassword}
                                        onClose={this.handleSnackbarClose}/>
                                    <Snackbar 
                                        open={this.props.message.changePassword ? true : false}
                                        message={this.props.message.changePassword}
                                        onClose={this.handleSnackbarClose}/>
                                </Grid>    
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs      sm={false} md={1}/>                  
                </Grid>
                
            </div>
        )            
    }
}

function mapStateToProps(state) {
    return { 
        errors: state.user.errors,
        message: state.user.message
    }   
}

function mapDispatchToProps(dispatch) {
    return {
        logInAction: (auth, history) => {
            dispatch(logInAction(auth, history))
        },
        recoverPasswordAction: (auth, history) => {
            dispatch(recoverPasswordAction(auth, history))
        },
        resetErrors: () => {
            dispatch(resetErrors())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login)));